export type MapVariableListRequestKey = {
  latitude: number | null;
  longitude: number | null;
  typeList: any;
  status: any;
  effectDateType: any;
  remark: any;
  operator: any;
  effectVehicleType: any;
};

export const buildRecordListRequestKey = (
  positionVal: any,
  searchformVal: any
): MapVariableListRequestKey => {
  return {
    latitude: positionVal?.lat ?? positionVal?.latitude ?? null,
    longitude: positionVal?.lon ?? positionVal?.longitude ?? null,
    typeList: searchformVal?.typeList ?? null,
    status: searchformVal?.status ?? null,
    effectDateType: searchformVal?.effectDateType ?? null,
    remark: searchformVal?.remark ?? null,
    operator: searchformVal?.operator ?? null,
    effectVehicleType: searchformVal?.effectVehicleType ?? null,
  };
};

export const isSameCoordinate = (
  left: number | null,
  right: number | null,
  epsilon = 1e-6
): boolean => {
  if (left === null || right === null) {
    return left === right;
  }
  return Math.abs(left - right) < epsilon;
};

export const serializeRecordListRequestFilters = (
  requestKey: MapVariableListRequestKey
) => {
  return JSON.stringify({
    typeList: requestKey.typeList,
    status: requestKey.status,
    effectDateType: requestKey.effectDateType,
    remark: requestKey.remark,
    operator: requestKey.operator,
    effectVehicleType: requestKey.effectVehicleType,
  });
};

export const isSameRecordListRequestKey = (
  left: MapVariableListRequestKey | null,
  right: MapVariableListRequestKey | null
) => {
  if (!left || !right) {
    return false;
  }

  return (
    isSameCoordinate(left.latitude, right.latitude) &&
    isSameCoordinate(left.longitude, right.longitude) &&
    serializeRecordListRequestFilters(left) ===
      serializeRecordListRequestFilters(right)
  );
};

// 行为埋点tag
export const clstagStr = (logId: string) => {
  return `h|keycount|${logId}`;
};
